import React, { useMemo, useReducer } from 'react';
import globalReducer from './reducer';

export const StateContext = React.createContext();
export const DispatchContext = React.createContext();

const initialState = {
  userObject: null,
  authModal: {
    state: false,
    tab: 'signup',
  },
  questionModal: {
    state: false,
    tab: 'signup',
  },
  leadMagnetModal: {
    state: false,
    tab: 'form1',
  },
  personaModal: {
    state: false,
  },
  teamInviteModal: {
    state: false,
  },
  editorParams: null,
  teamInviteInfoModal: {
    state: false,
  },
  teamSelectionModal: {
    state: false,
    data: null,
  },
  errorToast: {
    state: false,
    data: null,
  },
};

const ContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);

  const stateMemo = useMemo(() => state, [state]);
  const dispatchMemo = useMemo(() => dispatch, [dispatch]);

  return (
    <StateContext.Provider value={stateMemo}>
      <DispatchContext.Provider value={dispatchMemo}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};

export default ContextProvider;
